<template>
    <!-- <v-parallax src="../assets/survey.jpg" height="1300"> -->
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="user-survey">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm12 md11 lg10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title
                            >Bienvenido(a) {{ userName }}</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <!-- Container para contenido principal: -->
                    <v-container grid-list-md fluid>
                        <v-layout row wrap justify-space-around>
                            <v-flex xs9 md5 class="text-center">
                                <img
                                    :height="logoHeight"
                                    :src="companyLogoImg"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-space-around>
                            <v-flex
                                xs9
                                md5
                                class="text-center title font-weight-bold brown--text text--darken-4"
                                >{{ companyName }}</v-flex
                            >
                        </v-layout>
                        <br />

                        <v-layout row wrap justify-space-around>
                            <v-flex xs10 sm8 md6 class="text-center">
                                <v-progress-linear
                                    v-model="surveyProgress"
                                    height="20"
                                    color="orange accent-4"
                                >
                                    <strong
                                        >{{
                                            Math.round(surveyProgress)
                                        }}%</strong
                                    >
                                </v-progress-linear>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-space-around>
                            <v-flex
                                xs12
                                class="text-center deep-orange--text text--darken-4"
                                >Avance de la encuesta</v-flex
                            >
                        </v-layout>
                        <br />
                        <v-divider></v-divider>
                        <v-layout row wrap justify-space-around>
                            <v-flex
                                xs12
                                class="text-center font-weight-bold teal--text text--darken-3"
                                >Esta encuesta evalúa a: {{ userSurveyData.evaluado }}</v-flex
                            >
                        </v-layout>
                        <v-divider></v-divider>
                        <br />
                        <div v-if="moduleTitle !== ''">
                            <v-layout>
                                <v-flex
                                    xs12
                                    class="text-left font-weight-bold cyan--text text--darken-4 headline"
                                    >{{ moduleTitle }}</v-flex
                                >
                            </v-layout>
                            <v-divider class="cyan darken-4"></v-divider>
                            <br />
                        </div>

                        <div v-if="groupTitle !== ''">
                            <v-layout>
                                <v-flex
                                    xs12
                                    class="text-left font-weight-bold cyan--text text--darken-3 title"
                                    >{{ groupTitle }}</v-flex
                                >
                            </v-layout>
                            <v-divider class="cyan darken-3"></v-divider>
                            <br />
                        </div>

                        <div v-for="(question, i) in questionsToShow" :key="question.numPregunta">
                            <!-- Pregunta de opción múltiple: -->
                            <div v-if="question.tipo === 1">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">
                                        <span style="color: rgb(0, 105, 92)"
                                            >{{
                                                question.numPregunta
                                            }})&nbsp;</span
                                        >
                                        {{ question.pregunta }}
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs11 class="offset-xs1">
                                        <v-radio-group
                                            :column="$vuetify.breakpoint.smAndDown"
                                            :row="$vuetify.breakpoint.mdAndUp"
                                            v-model="question.respuestaUsuario"
                                            class="justify-center"
                                        >
                                            <!-- <v-radio
                                                v-for="(answer, j) in question.respuestas"
                                                :key="answer.num"
                                                :label="answer.texto"
                                                :value="answer.num"
                                                @change="onSelectAnswer({answer, question})"
                                                color="orange accent-4"
                                            ></v-radio> -->
                                            <v-container fluid>
                                                <v-layout row wrap justify-space-between>
                                                    <v-flex xs12 sm6 md4 v-for="(answer, j) in question.respuestas" :key = "answer.num">
                                                        <v-radio
                                                            :label="answer.texto"
                                                            :value="answer.num"
                                                            @change="onSelectAnswer({answer, question})"
                                                            color="orange accent-4">
                                                        </v-radio>
                                                    </v-flex>                                     
                                                </v-layout>
                                            </v-container>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <!-- Pregunta con respuestas etiquetadas como "alternativas": -->
                            <div v-else-if="question.tipo === 2">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta
                                    }}</v-flex>
                                </v-layout>
                                <v-radio-group
                                    row
                                    v-model="question.respuestaUsuario"
                                >
                                    <div
                                        v-for="(
                                            answer, j
                                        ) in question.respuestas"
                                        :key="answer.num"
                                    >
                                        <br />
                                        <v-layout row>
                                            <v-flex
                                                xs2
                                                class="text-right font-weight-bold cyan--text text--darken-4"
                                                >Alternativa
                                                {{ answer.num }}:</v-flex
                                            >
                                            <v-flex xs10>
                                                <v-radio
                                                    :label="answer.texto"
                                                    :value="answer.num"
                                                    @change="
                                                        onSelectAnswer({
                                                            answer,
                                                            question,
                                                        })
                                                    "
                                                    color="orange accent-4"
                                                ></v-radio>
                                            </v-flex>
                                        </v-layout>
                                        <br />
                                        <!-- <v-divider></v-divider> -->
                                    </div>
                                </v-radio-group>
                            </div>
                            <!-- Pregunta con respuestas a ordenar: -->
                            <div v-else-if="question.tipo === 3">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta
                                    }}</v-flex>
                                </v-layout>

                                <v-layout
                                    v-for="(answer, j) in orderedAnswers(
                                        question.respuestas
                                    )"
                                    :key="answer.respuesta"
                                >
                                    <v-flex xs3 md2 class="text-right">
                                        <span
                                            style="
                                                color: rgb(0, 105, 92);
                                                font-weight: bold;
                                            "
                                            >{{ answer.respuesta }})&nbsp;</span
                                        >
                                        &nbsp;
                                        <v-btn
                                            color="green darken-2"
                                            fab
                                            dark
                                            x-small
                                            @click="onUp(question, answer)"
                                            :disabled="answer.respuesta === '1'"
                                        >
                                            <v-icon
                                                >mdi-arrow-up-circle</v-icon
                                            > </v-btn
                                        >&nbsp;
                                        <v-btn
                                            color="red darken-3"
                                            fab
                                            dark
                                            x-small
                                            @click="onDown(question, answer)"
                                            :disabled="
                                                j ===
                                                question.respuestas.length - 1
                                            "
                                        >
                                            <v-icon
                                                >mdi-arrow-down-circle</v-icon
                                            >
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs9 md10 class="text-left">{{
                                        answer.texto
                                    }}</v-flex>
                                </v-layout>
                                <br />
                            </div>
                            <!-- Pregunta con respuesta de texto libre: -->
                            <div v-else-if="question.tipo === 4">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta
                                    }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-textarea
                                            dense
                                            outlined
                                            v-model="
                                                question.respuestas[0].respuesta
                                            "
                                            :auto-grow="false"
                                            no-resize
                                            color="cyan darken-3"
                                            rows="5"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <v-divider></v-divider>
                            <br />
                        </div>
                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="pink accent-3"
                                    class="text-none"
                                    text
                                    @click="onPrev"
                                    :disabled="!bShowPrevButton"
                                >
                                    <v-icon color="pink accent-3"
                                        >mdi-chevron-left</v-icon
                                    >Regresar
                                </v-btn>
                                <v-btn
                                    v-if="bShowNextButton"
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onNext"
                                >
                                    Continuar
                                    <v-icon color="cyan darken-3"
                                        >mdi-chevron-right</v-icon
                                    >
                                </v-btn>
                                <v-btn
                                    v-else
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onSend"
                                    :disabled="bSurveySent"
                                >
                                    Finalizar Encuesta &nbsp;
                                    <v-icon color="cyan darken-3"
                                        >mdi-check</v-icon
                                    >
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <!-- Modal para Disclaimer: **************************************** -->
                        <v-layout v-if="bShowDisclaimer" row justify-center>
                            <v-dialog
                                v-model="bShowDisclaimer"
                                persistent
                                :width="disclaimerWidth"
                            >
                                <v-card class="grey darken-4">
                                    <v-img
                                        :src="disclaimerImg"
                                        class="align-end"
                                        width="100%"
                                        gradient="to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0.87)"
                                    >
                                        <v-card-text class="cyan--text text--darken-3 headline text-center">
                                            <img
                                                height="110"
                                                :src="efectividadOrganizacionalLogo"
                                            />
                                            <br />
                                            <b>Talentwise SC, México, Consultoría empresarial</b>
                                        </v-card-text>
                                        <v-card-text class="teal--text text--lighten-4 body-2">
                                            Si deseas consultar nuestro aviso de privacidad desarrollado conforme a la legislación aplicable en México, lo podrás hacer haciendo clic aquí:
                                        </v-card-text>
                                        <v-card-text class="text-center">
                                            <v-btn
                                                color="cyan darken-2"
                                                class="text-none"
                                                text
                                                @click="onPrivacy">
                                                Aviso de Privacidad
                                            </v-btn>
                                        </v-card-text>    
                                         <v-card-text class="teal--text text--lighten-4 body-2">
                                            No guardamos cookies para ningún motivo comercial. Utilizamos la información esencial para el procesamiento de nuestros reportes. El propósito de nuestro trabajo es diseñar herramientas que apoyen a nuestros clientes en sus estrategias de desarrollo de talento para sus organizaciones. No enviamos correos promocionales ni nada semejante con la información que nuestros usuarios nos comparten.
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="cyan darken-2"
                                                class="text-none"
                                                text
                                                @click="onCloseDisclaimer"
                                                >Aceptar</v-btn
                                            >
                                            <v-btn
                                                color="pink accent-1"
                                                class="text-none"
                                                text
                                                @click="onExit"
                                                >Salir</v-btn
                                            >
                                        </v-card-actions>
                                    </v-img>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para Disclaimer *************************** -->
                        <!-- Modal para Introducción: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="showIntro"
                                persistent
                                :width="modalWidth"
                            >
                                <v-card class="grey darken-4">
                                    <v-card-text
                                        class="cyan--text text--darken-3 headline text-center"
                                    >
                                        <img
                                            height="170"
                                            :src="efectividadOrganizacionalLogo"
                                        />
                                        <br />
                                        <b
                                            >Talentwise México, Consultoría Empresarial</b
                                        >
                                    </v-card-text>
                                    <v-card-text
                                        class="teal--text text--lighten-4 text-sm-left enter-line"
                                    >
                                        {{ userSurveyData.intro }}
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="cyan darken-2"
                                            class="text-none"
                                            text
                                            @click="onBegin"
                                            >Comenzar</v-btn
                                        >
                                        <v-btn
                                            color="pink accent-1"
                                            class="text-none"
                                            text
                                            @click="onExit"
                                            >Salir</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para Introducción *************************** -->

                        <!-- Modal para pedir el nombre y apellido para el reporte (en encuestas masivas): *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgAskForName"
                                persistent
                                :width="nameReportModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container>    
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <div class="tw-green title font-weight-medium">
                                                    {{ $t('msg-escriba-el-nombre-para-el-reporte') }}
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-text-field
                                                    dense
                                                    color="teal darken-1"
                                                    :label="$t('lbl-nombre')"
                                                    type="text"
                                                    v-model="userSurveyData.nombre"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-text-field
                                                    dense
                                                    color="teal darken-1"
                                                    :label="$t('lbl-apellidos')"
                                                    type="text"
                                                    v-model="userSurveyData.apellido"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal"
                                            class="text-none"
                                            text
                                            @click="confirmUserName"
                                            :disabled = "((userSurveyData.nombre === '') || (userSurveyData.apellido === ''))"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir el nombre y apellido para el reporte (en encuestas masivas) *********************************** -->


                        <!-- Modal para pedir que se contesten todas las preguntas de opción múltiple: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bQuestionNotAnswered"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <!-- gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"  negro -->
                                            <!-- gradient="to bottom, rgba(0,105,92,0), rgba(0,105,92,1)"  teal darken-3 -->

                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img
                                                        height="90"
                                                        :src="
                                                            efectividadOrganizacionalLogo
                                                        "
                                                    />
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline</v-icon
                                                        >
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >Por favor conteste todas
                                                    las preguntas antes de
                                                    continuar.</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="
                                                            bQuestionNotAnswered = false
                                                        "
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se contesten todas las preguntas de opción múltiple *********************************** -->
                    </v-container>
                    <!-- Termina container para contenido principal -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import goTo from 'vuetify/es5/services/goto'; //Para scroll

export default {
    name: 'Languages',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',
            bShowDisclaimer: false,
            bHideIntro: false, //Indica si ya no se debe volver a desplegar la Introducción, en caso de haber.
            bDlgAskForName: false, //Indica si se debe pedir nombre para el reporte (cuando es una encuesta masiva).
            bQuestionNotAnswered: false, //Indica si el usuario dejó una pregunta de opción múltiple sin contestar.

            surveyProgress: 0, //Porcentaje de avance de la encuesta.

            nextModule: 0,
            nextQuestionGroup: 0,
            nextQuestionIndex: 0, //Indice de la siguiente pregunta a mostrar al hacer click en el botón "Siguiente". Va de 0 al número de preguntas del grupo actual menos uno.
            lastModule: 0,
            lastQuestionGroup: 0,
            lastQuestionIndex: 0, //Indice de la última pregunta mostrada.

            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            questionsToShow: [], //Arreglo de máximo 6 preguntas, que son las que se pueden mostrar a la vez.
            bShowNextButton: false,
            bShowPrevButton: false,
            moduleTitle: '',
            groupTitle: '',
            bSurveySent: false, //Para deshabilitar el botón "Finalizar Encuesta"
        };
    },
    components: {},
    created() {
        console.log('surveyCompany = ', this.surveyCompany);
        console.log('userSurveyData = ', this.userSurveyData);
        //console.log('breakpoints: ', this.$vuetify.breakpoint);
        // console.log(
        //     'Preguntas del módulo actual: ',
        //     this.userSurveyData.modulos[this.nextModule].gruposPreguntas[
        //         this.nextQuestionGroup
        //     ]
        //);
        window.addEventListener('beforeunload', (event) => {
            // Cancel the event as stated by the standard.
            // event.preventDefault();
            // Chrome requires returnValue to be set.
            //event.returnValue = '';
            window.alert('Saliendo');
            console.log('Saliendo...');
            this.$store.dispatch('testExit');
        });

        this.bShowDisclaimer = true;

        this.createQuestionsToShow();
    },
    beforeDestroy() {
        console.log('beforeDestroy...');
    },
    methods: {
        onCloseDisclaimer() {
            this.bShowDisclaimer = false;
        },
        onBegin() {
            this.bHideIntro = true;

            if (this.userSurveyData.pedirNombre)
            {
                this.bDlgAskForName = true;
            }
        },

        confirmUserName() {
            this.bDlgAskForName = false;
            console.log("onConfirmUserName, name = ", this.userSurveyData.nombre + " " + this.userSurveyData.apellido)
            this.$store.dispatch('updateUserSurveyName', this.userSurveyData.nombre + " " + this.userSurveyData.apellido);
        },

        onExit() {
            this.$store.dispatch('logout');
        },

        onSend() {
            //Valida que se hayan contestado todas las preguntas de opción múltiple de la última ventana:
            var i;
            for (i = 0; i < this.questionsToShow.length; i++) {
                if (
                    this.questionsToShow[i].tipo === 1 ||
                    this.questionsToShow[i].tipo === 2
                ) {
                    if (this.questionsToShow[i].respuestaUsuario === 0) {
                        this.bQuestionNotAnswered = true;
                        break;
                    }
                }
            }

            if (!this.bQuestionNotAnswered) {
                console.log('Enviando encuesta, userSurveyData = ', this.userSurveyData);
                this.bSurveySent = true; //Para deshabilitar el botón "Finalizar Encuesta"
                this.$store.dispatch('sendUserSurvey');
            }
        },

        onSelectAnswer({ answer, question }) {
            //console.log('answer = ', answer);
            //console.log('question = ', question);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                if (question.respuestas[i].num === answer.num) {
                    question.respuestas[i].respuesta = '1';
                } else {
                    question.respuestas[i].respuesta = '0';
                }
            }

            //console.log('question = ', question);
        },

        createQuestionsToShow() {
            //Genera un bloque de máximo 6 preguntas, que son las que se pueden mostrar a la vez:

            var bEndReached = false; //Indica si ya se terminó de recorrer todo el arreglo de preguntas.

            var iQuestions = 0;
            this.questionsToShow = [];
            var i;
            var numQuestions = 0;

            //console.log('Al iniciar creatQuestionsToShow, nextQuestionIndex = ', this.nextQuestionIndex);

            //console.log('userSurveyData.modulos = ', this.userSurveyData.modulos);
            //console.log('nextModule = ', this.nextModule);
            //console.log('nextQuestionGroup = ', this.nextQuestionGroup);
            //console.log('Empezando en ', this.userSurveyData.modulos[this.nextModule].gruposPreguntas);

            var currentWndQuestions = 0; //Número de preguntas de la ventana actual
            var lastQuestionNumber = 0; //Número general de la última pregunta

            for (
                i = this.nextQuestionIndex;
                i <
                this.userSurveyData.modulos[this.nextModule].gruposPreguntas[
                    this.nextQuestionGroup
                ].preguntas.length;
                i++
            ) {
                currentWndQuestions++;
                lastQuestionNumber = this.userSurveyData.modulos[
                    this.nextModule
                ].gruposPreguntas[this.nextQuestionGroup].preguntas[i].numGral;

                this.lastQuestionIndex = this.nextQuestionIndex;
                this.lastQuestionGroup = this.nextQuestionGroup;
                this.lastModule = this.nextModule;

                this.moduleTitle = this.userSurveyData.modulos[
                    this.nextModule
                ].tituloModulo;
                this.groupTitle = this.userSurveyData.modulos[
                    this.nextModule
                ].gruposPreguntas[this.nextQuestionGroup].tituloGrupo;

                var tempQuestion = this.userSurveyData.modulos[this.nextModule]
                    .gruposPreguntas[this.nextQuestionGroup].preguntas[i];
                var question = {
                    numPregunta: tempQuestion.numPregunta,
                    pregunta: tempQuestion.pregunta,
                    tipo: tempQuestion.tipo,
                    respuestas: tempQuestion.respuestas,
                    respuestaUsuario: 0, //Se agrega para asociar al v-model del radio
                };

                //Checa si la pregunta ya tiene alguna respuesta seleccionada por el usuario:
                var j;
                for (j = 0; j < tempQuestion.respuestas.length; j++) {
                    if (tempQuestion.respuestas[j].respuesta === '1') {
                        question.respuestaUsuario =
                            tempQuestion.respuestas[j].num;
                        break;
                    }
                }
                this.questionsToShow.push(question);
                this.nextQuestionIndex++;
                numQuestions++;

                //console.log('nextQuestionIndex = ', this.nextQuestionIndex);

                //Sólo se despliegan 6 preguntas por ventana:
                if (numQuestions > 5) {
                    break;
                }
            }

            this.surveyProgress =
                ((lastQuestionNumber - currentWndQuestions) /
                    this.surveyNumQuestions) *
                100;

            //Se dejan los índices preparados para la próxima vez que se presione el botón "Continuar":

            //Se checa si ya se terminó el grupo de preguntas actual y la encuesta:
            this.bShowNextButton = true;
            //console.log('Antes de checar si ya se terminó el grupo de preguntas actual, nextQuestionIndex = ', this.nextQuestionIndex);
            if (
                this.nextQuestionIndex + 1 >
                this.userSurveyData.modulos[this.nextModule].gruposPreguntas[
                    this.nextQuestionGroup
                ].preguntas.length
            ) {
                //Cambio de Grupo de preguntas:
                this.nextQuestionIndex = 0;
                this.nextQuestionGroup++;

                //Se checa si se terminaron todas las preguntas del grupo de preguntas, se pasa al siguiente módulo:
                if (
                    this.nextQuestionGroup + 1 >
                    this.userSurveyData.modulos[this.nextModule].gruposPreguntas
                        .length
                ) {
                    //Cambio de Módulo:
                    //console.log('Se terminaron todas las preguntas del grupo...');
                    this.nextQuestionGroup = 0;
                    this.nextModule++;

                    //Se checa si ya se terminaron de recorrer todos los módulos:
                    //console.log('nextModule = ', this.nextModule);
                    //console.log('userSurveyData.modulos = ', this.userSurveyData.modulos);
                    if (
                        this.nextModule + 1 >
                        this.userSurveyData.modulos.length
                    ) {
                        //console.log('Se terminaron todos los módulos...');
                        this.bShowNextButton = false;

                        //Como ya estamos en la última ventana de la encuesta, se pone el avance en 100%:
                        this.surveyProgress = 100;
                    }
                }
            }

            //Se checa si se debe habilitar el botón "Regresar"
            if (
                this.nextModule === 0 &&
                this.nextQuestionGroup === 0 &&
                this.nextQuestionIndex < 7
            ) {
                this.bShowPrevButton = false;
            } else {
                this.bShowPrevButton = true;
            }

            goTo(0); //Scroll hasta arriba.
        },

        onNext() {
            //Valida que se hayan contestado todas las preguntas de opción múltiple de la ventana:
            var i;
            for (i = 0; i < this.questionsToShow.length; i++) {
                if (
                    this.questionsToShow[i].tipo === 1 ||
                    this.questionsToShow[i].tipo === 2
                ) {
                    if (this.questionsToShow[i].respuestaUsuario === 0) {
                        this.bQuestionNotAnswered = true;
                        break;
                    }
                }
            }

            if (!this.bQuestionNotAnswered) {
                this.createQuestionsToShow();
            }
        },

        onPrev() {
            //Si el índice de la última pregunta es mayor a 5, no hay que cambiar de grupo ni de módulo,
            //nada más hay que disminuir el índice de la pregunta:
            if (this.lastQuestionIndex > 5) {
                //Hay que moverse al inicio de la ventana anterior. Para esto, se va decrementando el índice de la
                //pregunta hasta que es múltiplo de 6, y cuando se llega a este valor, al índice se le restan 6.
                //Esto coloca el índice al inicio de la ventana anterior.
                var i;
                for (i = this.lastQuestionIndex; i > 0; i--) {
                    var iResidue = i % 6;
                    if (iResidue === 0) {
                        break;
                    }
                }

                //this.nextQuestionIndex = this.lastQuestionIndex - 6;
                this.nextQuestionIndex = i - 6;
                this.nextQuestionGroup = this.lastQuestionGroup;
                this.nextModule = this.lastModule;
            } //lastQuestionIndex < 5
            else {
                //Hay que checar si se debe cambiar a un grupo anterior o a un módulo anterior:
                if (this.lastQuestionGroup > 0) {
                    //Permanece en el mismo módulo, pero se baja al grupo de preguntas anterior (a la última ventana del grupo):
                    this.nextModule = this.lastModule;
                    this.nextQuestionGroup = this.lastQuestionGroup - 1;

                    //Se posiciona al principio del último bloque de preguntas del grupo:
                    var numberOfQuestions = this.userSurveyData.modulos[
                        this.nextModule
                    ].gruposPreguntas[this.nextQuestionGroup].preguntas.length;

                    var windowIndex = (numberOfQuestions - 1) / 6;
                    windowIndex = Math.floor(windowIndex);
                    //console.log('numberOfWidows = ', windowIndex);

                    this.nextQuestionIndex = windowIndex * 6;

                    //console.log('windowIndex = ', windowIndex);
                    //console.log('nextQuestionIndex = ', this.nextQuestionIndex);
                } //lastQuetionGroup === 0
                else {
                    //Se disminuye el módulo. Hay que moverse al principio del último grupo del módulo anterior:
                    this.nextModule = this.lastModule - 1;
                    this.nextQuestionGroup =
                        this.userSurveyData.modulos[this.nextModule]
                            .gruposPreguntas.length - 1;

                    //Se posiciona en la última ventana del grupo. Para esto, primero se posiciona en la última pregunta,
                    //y se va decrementando el índice de la pregunta hasta que sea múltiplo de 6.
                    //Esto coloca el índice al inicio de la última ventana del grupo.
                    var i;
                    for (
                        i =
                            this.userSurveyData.modulos[this.nextModule]
                                .gruposPreguntas[this.nextQuestionGroup]
                                .preguntas.length - 1;
                        i > 0;
                        i--
                    ) {
                        var iResidue = i % 6;
                        if (iResidue === 0) {
                            break;
                        }
                    }

                    this.nextQuestionIndex = i;
                }
            }
            this.createQuestionsToShow();
        },
        onUp(question, answer) {
            var selectedAnswerNum = parseInt(answer.respuesta);
            var newSelectedAnswerNum = selectedAnswerNum - 1;
            //console.log('selectedAnswerNum = ', selectedAnswerNum);
            //console.log('newSelectedAnswerNum = ', newSelectedAnswerNum);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                var answerNum = parseInt(question.respuestas[i].respuesta);

                //Si es la respuesta a editar, se baja su índice:
                if (answerNum === selectedAnswerNum) {
                    question.respuestas[
                        i
                    ].respuesta = newSelectedAnswerNum.toString();
                }
                //Si la respuesta tiene el mismo índice que el nuevo índice de la respuesta seleccionada
                //se aumenta su índice, para recorrerla:
                else if (answerNum === newSelectedAnswerNum) {
                    answerNum++;
                    question.respuestas[i].respuesta = answerNum.toString();
                }
            }
            //console.log('question = ', question);
        },
        onDown(question, answer) {
            var selectedAnswerNum = parseInt(answer.respuesta);
            var newSelectedAnswerNum = selectedAnswerNum + 1;
            //console.log('selectedAnswerNum = ', selectedAnswerNum);
            //console.log('newSelectedAnswerNum = ', newSelectedAnswerNum);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                var answerNum = parseInt(question.respuestas[i].respuesta);

                //Si es la respuesta a editar, se baja su índice:
                if (answerNum === selectedAnswerNum) {
                    question.respuestas[
                        i
                    ].respuesta = newSelectedAnswerNum.toString();
                }
                //Si la respuesta tiene el mismo índice que el nuevo índice de la respuesta seleccionada
                //se aumenta su índice, para recorrerla:
                else if (answerNum === newSelectedAnswerNum) {
                    answerNum--;
                    question.respuestas[i].respuesta = answerNum.toString();
                }
            }
            //console.log('question = ', question);
        },

        orderedAnswers(answers) {
            //Ordena el arreglo de respuestas con base en el campo 'respuesta':
            return _.orderBy(answers, 'respuesta');
        },

        onPrivacy()
        {
            window.open('https://www.retroalimentame.com.mx/PDF/AvisoPrivacidad.pdf');
        },
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'efectividadOrganizacionalLogo',
            'disclaimerImg',
            'userName',
            'surveyCompany',
            'companyLogoImg',
            'userSurveyData',
            'surveyNumQuestions',
        ]),

        showIntro() {
            var bShowIntro = false;
            if (this.userSurveyData.intro !== '' && !this.bHideIntro) {
                bShowIntro = true;
            }
            return bShowIntro;
        },

        companyName() {
            var strName = '';
            if (this.surveyCompany !== null) {
                strName = this.surveyCompany.empresanombre;
            }
            return strName;
        },

        selectedLanguageIndex: {
            get() {
                return this.$store.getters.selectedLanguageIndex;
            },
            set(selectedLanguageIndex) {
                this.$store.dispatch(
                    'updateSelectedLanguageIndex',
                    selectedLanguageIndex
                );
            },
        },

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '75%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '65%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '35%';
            }
            return width;
        },

        nameReportModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '50';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '60';
            } else if (this.$vuetify.breakpoint.md) {
                height = '70';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },

        disclaimerWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '75%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '40%';
            }
            return width;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.85);
}
.user-survey {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

.enter-line {
    white-space: pre-wrap;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>